<template>
    <div>
      <el-dialog
        :visible.sync="dialogVipVisible"
        width="80%"
        :before-close="handleClose"
        :append-to-body="true"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        z-index="99999"
        :show-close="false"
        :class="{ 'fullscreen-mode': isFullscreen }"
      >
        <div slot="title" class="dialog-title">
          <span class="name">{{ name }}</span>
          <i class="fangda" @click="toggleFullscreen" />
          <i class="close-nb" @click="handleClose" />
        </div>
        <div class="iframe-container" :class="{ 'fullscreen-mode': isFullscreen }">
          <iframe
            ref="iframe"
            :src="url"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
            allow="clipboard-read; clipboard-write"
            class="custom-iframe"
          ></iframe>
        </div>
      </el-dialog>
    </div>
</template>
  
<script>
export default {
  name: "NbBook",
  props: ["dialogVipVisible", "name", 'url'],
  data() {
    return {
      isLoading: true,
      isFullscreen: false
    };
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    handleKeyDown(e) {
      if (e.key === 'Escape') {
        if (this.isFullscreen) {
          e.preventDefault();
          this.toggleFullscreen();
        }
      }
    },
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      if (this.isFullscreen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    handleClose() {
      this.isFullscreen = false;
      document.body.style.overflow = '';
      this.$emit("closePayActivity");
    },
  },
};
</script>
  
<style scoped>
::v-deep .el-dialog__wrapper {
  min-width: 600px;
  max-width: 80%;
}

::v-deep .el-dialog {
  margin-top: 6vh !important;
  height: 85vh;
  transform-origin: center;
}

::v-deep .el-dialog__headerbtn {
  outline: none !important;
  border: none !important;
}

::v-deep .el-dialog__header {
  width: 100%;
  height: 41px;
  padding: 0;
  margin: 0;
  .dialog-title {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .name {
      position: absolute;
      left: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0px;
      color: #323233;
    }
  }
}

::v-deep .el-dialog__body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: relative;
}

.fangda {
  position: absolute;
  width: 17px;
  height: 17px;
  top: 12px;
  right: 60px;
  background: url(../../assets/images/chat/big.png) no-repeat center;
  background-size: 100% 100%;
  cursor: pointer;
}
.close-nb {
  position: absolute;
  width: 13px;
  height: 13px;
  top: 14px;
  right: 30px;
  background: url(../../assets/images/chat/clonenb.png) no-repeat center;
  background-size: 100% 100%;
  cursor: pointer;
}

.iframe-container {
  width: 100%;
  height: 100%;
  position: relative;
  transform-origin: center;
}

.iframe-container.fullscreen-mode {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background: #fff;
  transform-origin: center;
  animation: fullscreen-in 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes fullscreen-in {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.custom-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

::v-deep .el-dialog.fullscreen-mode {
  margin-top: 0 !important;
  height: 100vh !important;
  transform-origin: center;
  animation: dialog-fullscreen-in 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes dialog-fullscreen-in {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
  